export default __webpack_public_path__ + "static/media/yuhangyuan_img@2x.b81b7f7c.png";